import { Component, OnInit } from '@angular/core';
import { IGenericResponse } from 'src/app/models/IGenericResponse';
import { LRV, ProductosAsociados } from 'src/app/models/Lead-reseller-vf';
import { PanelAdminService } from 'src/app/service/panel-admin.service';
import { ColumnaTabla } from 'src/app/models/Tabla';
import { LoginService } from 'src/app/service/login.service';
import { Router } from '@angular/router';
import { IFormulario } from 'src/app/models/Formulario';
import { EditarUsuario } from 'src/app/models/PanelAdministracion';
import { NotificationService } from 'src/app/service/notificaciones.service';
import { Dropdown } from 'primeng/dropdown';
import { MenuItem } from 'primeng/api';
import { MenuState } from 'src/app/state/menu.state';
@Component({
  selector: 'app-panel-admin',
  templateUrl: './panel-admin.component.html',
  styleUrls: ['./panel-admin.component.css']
})
export class PanelAdminComponent implements OnInit {

  lista_usuarios: LRV[]=[];
  datos_usuario_seleccionado: EditarUsuario = {} as EditarUsuario;
  lista_productos: ProductosAsociados[]=[];
  distribuidores_dropdown: Dropdown[]=[];
  dialog: boolean = false;
  cabecera_dialog: string = "";
  tipo_dialogo: string = "";
  
  columnas: ColumnaTabla[] = [
    { field: 'id', header: 'ID', type: 'number', filter: true },
    { field: 'nombre', header: 'Nombre', type: 'string', filter: true },
    { field: 'apellidos', header: 'Apellidos', type: 'string', filter: true },
    { field: 'dni', header: 'DNI', type: 'string', filter: true },
    { field: 'email', header: 'Email', type: 'string', filter: true },
    { field: 'calle_numero', header: 'Dirección', type: 'string', filter: true },
    { field: 'cp', header: 'Código Postal', type: 'string', filter: true },
    { field: 'poblacion', header: 'Población', type: 'string', filter: true },
    { field: 'provincia', header: 'Provincia', type: 'string', filter: true },
    { field: 'telefono', header: 'Teléfono', type: 'string', filter: true },
    { field: 'telefono_2', header: 'Segundo Teléfono', type: 'string', filter: true },
    { field: 'residencial_negocio', header: 'Producto', type: 'string', filter: true },
    { field: 'nombre_distribuidor', header: 'Nombre Distribuidor', type: 'string', filter: true },
    { field: 'comentarios', header: 'Comentarios', type: 'string', filter: false },
  ];
  columnas_productos: ColumnaTabla[] = [
    { field: 'producto', header: 'Productos', type: 'string', filter: false }
  ];
  formulario_editar_usuario: IFormulario[] = [
    { fields: ['cabecera'], headers: ['Editar Usuario'], type: ['cabecera'], options: [{disabled: true}], parametros: [{strong: true, justify_content: 'center', color: 'red', font_size: '23px', margin_bottom: '1%'}], validador: [false] },
    { fields: ['nombre'], headers: ['Nombre'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['apellidos'], headers: ['Apellidos'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['dni'], headers: ['DNI'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['email'], headers: ['Email'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['calle_numero'], headers: ['Dirección'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['cp'], headers: ['Código Postal'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['poblacion'], headers: ['Población'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['provincia'], headers: ['Provincia'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['telefono'], headers: ['Teléfono'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['telefono_2'], headers: ['Segundo Teléfono'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['comentarios'], headers: ['Comentarios'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['residencial_negocio'], headers: ['Producto'], type: ['text'], options: [], parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['nombre_distribuidor'], headers: ['Nombre Distribuidor'], type: ['dropdown'], options: this.distribuidores_dropdown, parametros: [{tipo:'string'}], validador: [true] },
    { fields: ['enviar'], headers: ['Editar'], type: ['boton-enviar'], options: [], parametros: [{ color: 'red' }], validador: [false] },
  ];

  opciones_menu: MenuItem[] = [];
  constructor(private PanelAdminService: PanelAdminService, private loginService: LoginService, 
              private router: Router, private notificacionesService: NotificationService, 
              private menuState: MenuState) {}
  
  ngOnInit(): void {
    const token = this.loginService.getToken();
    if (!token ) {
      console.log('El token no existe.');
      this.router.navigate(['/login']);
    }
    if(this.loginService.tokenExpirado(token)){
      console.log('El token ha expirado.');
      this.loginService.deleteToken();
      this.router.navigate(['/login']);
    } 
    this.inicializarPanel();
    this.opciones_menu = this.menuState.items_menu;
  }

  inicializarPanel(){
    this.PanelAdminService.getUsuarios().subscribe((response: IGenericResponse) => {
      this.lista_usuarios = response.data;
      this.PanelAdminService.getDistribuidores().subscribe((response: IGenericResponse) => {
        const distribuidoresDropdown = response.data.map((distribuidor: any) => ({
          id: distribuidor.id,
          name: distribuidor.nombre_comercial,
        }));
        this.distribuidores_dropdown = distribuidoresDropdown;
        this.formulario_editar_usuario.find((field) => field.fields.includes('nombre_distribuidor'))!.options = this.distribuidores_dropdown;
      })
    });
  }
  verProductosAsociados(usuario: LRV){
    this.PanelAdminService.getProductosAsociados(usuario.id).subscribe((response: IGenericResponse) => {
      this.lista_productos = response.data;
      this.tipo_dialogo = "productos";
      this.dialog = true;
    })
  }
  editarUsuario(usuario: EditarUsuario) {
    console.log(usuario)
    const distribuidor = this.distribuidores_dropdown.find(distribuidor => distribuidor.name === usuario.nombre_distribuidor);
    const { id, nombre, apellidos, dni, email, calle_numero, cp, poblacion, provincia, telefono, telefono_2, comentarios, nombre_distribuidor, residencial_negocio } = usuario;
    const editar_usuario: EditarUsuario = { id, nombre, apellidos, dni, email, calle_numero, cp, poblacion, provincia, telefono, telefono_2, comentarios, nombre_distribuidor, residencial_negocio };
    
    editar_usuario.nombre_distribuidor = distribuidor?.name;
    this.datos_usuario_seleccionado = editar_usuario;
    this.dialog = true;
    this.tipo_dialogo = 'editar';
  }

  onRecibirFormulario(formulario: any) {
    console.log(formulario)
    formulario.id = this.datos_usuario_seleccionado.id;
    this.PanelAdminService.editarUsuario(formulario).subscribe((response: IGenericResponse) => {
      if(response.error){
        this.notificacionesService.notificacionError(response.error);
      } else{
        this.dialog = false;
        this.notificacionesService.notificacionSuccess(response.message);
        this.PanelAdminService.getUsuarios().subscribe((response: IGenericResponse) => {
          this.lista_usuarios = response.data;
        })
      }
    })
  }
}
